export const generateTitleKey = (sectionKey: string): string => `${sectionKey}_tooltip_title`;
export const generateDescriptionKey = (sectionKey: string): string => `${sectionKey}_tooltip_description`;
export const generateThumbnailKey = (sectionKey: string): string => `${sectionKey}_tooltip_thumbnail`;
export const generateVideoIdKey = (sectionKey: string): string => `${sectionKey}_tooltip_video_id`;
